// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"159":"1048887a","835":"a6354c05"}[chunkId] + ".chunk.css";
};